module.exports = __webpack_public_path__ + "static/mingyun2-07d5fabf410f7845db5c6ec324545cf4.jpg";